<template lang="pug">
v-card(:to="to", flat, tile)
  img.event-card-img(v-responsive="1.6", :src="img")
  .event-card-title.font-weight-bold.text-body-2.text-capitalize.grey--text.text--darken-4.px-2.text-center.mt-3.mb-4
    .open-sans {{ title }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.event-card-img {
  object-fit: cover;
  width: 100%;
}
.event-card-title {
  border-width: 0px 0px 0px 3px;
}
</style>
